import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable({
  providedIn: 'root'
})
export class HeadersInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader);

      return next.handle(req.clone({ headers }));
    } else {
      const request = req.clone({
        headers: req.headers.append('Content-Type', 'application/json').append('Accept', 'application/json')
      });

      return next.handle(request);
    }
  }
}
